module.exports = __webpack_public_path__ + "static/img/imageBack.befc273b.png";